<div class="message is-fullwidth">

  <div class="message-header" (dblclick)="toggleMinimizeFilters()">
    <p i18n>Filters</p>
    <button (click)="toggleMinimizeFilters()">
      <span class="icon is-small">
        @if (!filtersMinimized) {
          <i-feather name="chevron-up"></i-feather>
        } @else {
          <i-feather name="chevron-down"></i-feather>
        }
      </span>
    </button>
  </div>

  @if (!filtersMinimized) {
    <div class="message-body">
      <div class="columns">
        <div class="column">
          <div class="label label-select">
            <span i18n>Type of statistic</span>
            <div class="select is-fullwidth is-multiple">
              <select multiple [(ngModel)]="statisticFilters.type" (change)='multiToMonoSelectStatistic()'>
                @if (statisticTypes) {
                  @for (type of statisticTypes; track type) {
                    <option [ngValue]="type.id">
                      {{ type.label }}
                    </option>
                  }
                }
              </select>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="label label-select">
            <span i18n>NCode-D</span>@if (statisticFilters.ncode.code.length > 0) {
            <span>
            ({{ statisticFilters.ncode.code.length }})</span>
          }
          @if ((nCodes$ | async); as nCodes) {
            <app-combo-select [options]="nCodes"
              [labelAttr]="['code', 'codeLabel']" valueAttr="code"
              [(ngModel)]="statisticFilters.ncode.code"
              [disabled]="true || statisticFilters.type.length === 0 || statisticFilters.type[0].startsWith('user')"/>
          }
        </div>
      </div>
      <div class="column">
        <div class="label label-select">
          <span i18n>Class</span>@if (statisticFilters.ncode.classCode.length > 0) {
          <span>
          ({{ statisticFilters.ncode.classCode.length }})</span>
        }
        @if ((classes$ | async); as classes) {
          <app-combo-select [options]="classes"
            [labelAttr]="['code', 'label']" valueAttr="code"
            [(ngModel)]="statisticFilters.ncode.classCode"
            [disabled]="true || statisticFilters.type.length === 0 || statisticFilters.type[0].startsWith('user')"/>
        }
      </div>
    </div>
  </div>
  <div class="columns">
    <div class="column"></div>
    <div class="column">
      <div class="label label-select">
        <span i18n>Monitor</span>@if (statisticFilters.results.monitor.length > 0) {
        <span>
        ({{ statisticFilters.results.monitor.length }})</span>
      }
      <div class="select is-fullwidth is-multiple">
        <select multiple [(ngModel)]="statisticFilters.results.monitor"
          [disabled]="true || statisticFilters.type.length === 0 || statisticFilters.type[0] !== 'final_result'">
          @if ((monitors$ | async); as monitors) {
            @for (monitor of monitors; track monitor) {
              <option [ngValue]="monitor.name">{{ monitor.internalName }}</option>
            }
          }
        </select>
      </div>
    </div>
  </div>
  <div class="column">
    <div class="label label-select">
      <div class="control">
        <ng-container i18n>On sCAPI</ng-container>&nbsp;
        @if (statisticFilters.assignedScapiUsername.length > 0) {
          <span>
          ({{ statisticFilters.assignedScapiUsername.length }})</span>
        }
      </div>
      @if (userGroups$ | async; as userGroups) {
        @if (userGroups.indexOf(scapiGroupName!) > -1) {
        <app-combo-select [options]="(operatorsScapi$ | async)" [labelAttr]="['username']" valueAttr="username"
        [(ngModel)]="statisticFilters.assignedScapiUsername"
        [disabled]="statisticFilters.type.length === 0 || !statisticFilters.type[0].startsWith('user')"/>
      } @else {
        <app-combo-select [options]="[]" [labelAttr]="['username']" valueAttr="username"
          [(ngModel)]="statisticFilters.assignedScapiUsername"/>
      }
    }
    </div>
  </div>
</div>
<div class="columns">
  <div class="checkbox-row">
    <div class="label label-select is-flex is-flex-direction-column">
      <ng-container i18n>sCAPI state</ng-container>
      <div class="select">
        <select [(ngModel)]="statisticFilters.scapiState"
          [disabled]="true || statisticFilters.type.length === 0 ||  statisticFilters.type === 'user_history'">
          @if (scapiStates) {
            @for (state of scapiStates; track state) {
              <option [ngValue]="state.id">
                {{ state.label }}
              </option>
            }
          }
        </select>
      </div>
    </div>
    <div class="label label-select is-flex is-flex-direction-column">
      <ng-container i18n>Selected for sFB</ng-container>
      <div class="select">
        <select [(ngModel)]="checkSfb"
          [disabled]="true || statisticFilters.type.length === 0 ||  statisticFilters.type[0].startsWith('user')">
          <option [value]="null"></option>
          <option [value]="true">
            <ng-container i18n>Yes</ng-container>
          </option>
          <option [value]="false">
            <ng-container i18n>No</ng-container>
          </option>
        </select>
      </div>
    </div>
    <div class="label label-select is-flex is-flex-direction-column">
      <ng-container i18n>Date from</ng-container>
      <input [(ngModel)]="statisticFilters.date.from" class="input" type="date"
        [disabled]="statisticFilters.type.length === 0 || statisticFilters.type[0] !== 'user_history'">
    </div>
    <div class="label label-select is-flex is-flex-direction-column">
      <ng-container i18n>Date to</ng-container>
      <input [(ngModel)]="statisticFilters.date.to" class="input" type="date"
        [disabled]="statisticFilters.type.length === 0 || statisticFilters.type[0] !== 'user_history'">
    </div>
  </div>
</div>
<div class="buttons">
  @if (!loadingStatistics) {
    <button class="button is-primary"
      (click)="requestStatistics()" [disabled]="statisticFilters.type.length === 0">
      <strong i18n>Apply filters</strong>
    </button>
  } @else {
    <button class="button is-primary" disabled>
      <div class="loader"></div>
      <strong i18n>Apply filters</strong>
    </button>
  }

  <button class="button" (click)="resetStatisticsFilters()" [disabled]="loading">
    <ng-container i18n>Reset filters</ng-container>
  </button>
</div>
</div>
}
</div>


@if (statistics && statistics.length > 0) {
  <div class="table-container" id="stats-table"
    [ngClass]="{'navbar-visible': statistics.length >= 1}">
    <button class="button is-light is-small"
      (click)="saveStatistics()">
      <span class="icon is-small">
        <i-feather name="save" class="icon-smaller"></i-feather>
      </span>
    </button>
    <table class="table is-narrow is-hoverable is-fullwidth table-compact">
      <thead>
        <tr>
          @for (column of statColumns; track column) {
            <th [ngClass]="getColumnNameClass(column.real)"
              (click)="statisticSortBy(column.real)" class="has-text-centered">
              <div class="cell-wrapper is-align-items-center">
                @if (statisticSorting && statisticSorting.field === column.real) {
                  @if (statisticSorting.direction === 'ASC') {
                    <i-feather class="sort-direction-indicator"
                    name="chevron-up"></i-feather>
                  } @else {
                    <i-feather class="sort-direction-indicator" name="chevron-down"></i-feather>
                  }
                }
                {{ column.readable }}
              </div>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (stat of statistics; track stat) {
          <tr [ngClass]="getRowClass(stat['code'], stat['date'], stat['user'])">
            @for (column of statColumns; track column) {
              <td [ngClass]="getColumnClass(column.real)" class="has-text-centered">
                {{ stat[column.real] }}
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
}
